export default {
    year: '年',
    month: '月',
    day: '日',
    hour: '时',
    minute: '分',
    am: '上午',
    pm: '下午'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmc-date-picker/es/locale/zh_CN.js
// module id = 688
// module chunks = 0